/* Vorhandene Produktkarten seitenweise nachladen; normale Links bleiben die Rückfallebene. */
class EtanaLoadMore extends HTMLElement {
  connectedCallback() {
    // Filter aus dem Seitencache aktualisieren die Adresse erst nach dem Einfügen.
    queueMicrotask(() => { if (this.isConnected) this.initialize(); });
  }

  initialize() {
    this.list = this.querySelector('[data-load-more-list]');
    this.controls = this.querySelector('[data-load-more-controls]');
    if (!this.list || !this.controls) return;
    this.pages = [];
    this.pageUrl = location.pathname + location.search;
    this.controller = new AbortController();
    this.setAttribute('data-enhanced', '');
    this.addEventListener('click', this.onClick = (event) => {
      const link = event.target.closest('a');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (link.matches('[data-load-more-next]')) {
        if (this.failed) return;
        event.preventDefault();
        this.loadNext(true);
      } else if (this.list.contains(link)) {
        this.remember();
      }
    });
    const saved = history.state && history.state.etanaLoadMore;
    if (saved && saved.url === this.pageUrl && Array.isArray(saved.pages)) this.restore(saved);
  }

  disconnectedCallback() {
    if (this.controller) this.controller.abort();
    if (this.onClick) this.removeEventListener('click', this.onClick);
  }

  remember(scrollY = window.scrollY) {
    // Nur der aktuelle Verlaufseintrag; keine Cookies, kein dauerhafter Produktspeicher.
    history.replaceState({...history.state, etanaLoadMore: {
      url: this.pageUrl, pages: this.pages.slice(), scrollY
    }}, '');
  }

  async restore(saved) {
    for (const page of saved.pages) {
      const next = this.controls.querySelector('[data-load-more-next]');
      if (!next || new URL(next.href).pathname + new URL(next.href).search !== page) break;
      if (!await this.loadNext(false)) return;
    }
    if (this.isConnected && Number.isFinite(saved.scrollY)) {
      requestAnimationFrame(() => {
        if (this.isConnected) window.scrollTo(0, saved.scrollY);
      });
    }
  }

  async loadNext(focusNew) {
    const next = this.controls.querySelector('[data-load-more-next]');
    if (!next || this.loading) return false;
    const url = new URL(next.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname) return false;
    const page = url.pathname + url.search;
    if (this.pages.includes(page)) return false;
    const text = next.textContent;
    const messages = {...this.controls.dataset};
    const status = this.controls.querySelector('[role="status"]');
    this.loading = true;
    next.setAttribute('aria-disabled', 'true');
    this.list.setAttribute('aria-busy', 'true');
    next.textContent = messages.loading;
    status.textContent = '';
    url.searchParams.set('section_id', this.dataset.sectionId);
    const timeout = setTimeout(() => this.controller.abort(), 20000);
    try {
      const response = await fetch(url, {signal: this.controller.signal});
      if (!response.ok) throw new Error('Nachladen fehlgeschlagen');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const source = html.querySelector('etana-load-more');
      const list = source && source.querySelector('[data-load-more-list]');
      const controls = source && source.querySelector('[data-load-more-controls]');
      if (!list || !list.children.length || !controls) throw new Error('Ungültige Ergebnisseite');
      if (!this.isConnected) return false;
      const firstNew = list.firstElementChild;
      this.list.append(...list.children);
      this.controls.replaceWith(controls);
      this.controls = controls;
      this.pages.push(page);
      this.remember();
      const liveStatus = controls.querySelector('[role="status"]');
      // Erst nach dem Einfügen befüllen, damit die Live-Meldung angekündigt wird.
      requestAnimationFrame(() => {
        liveStatus.textContent = controls.querySelector('[data-load-more-next]') ? messages.loaded : messages.end;
      });
      if (focusNew) firstNew.querySelector('a[href]')?.focus({preventScroll: true});
      return true;
    } catch (error) {
      if (this.isConnected) {
        this.failed = true;
        status.textContent = messages.error;
        // Beim nächsten Klick wird der unveränderte Seitenlink normal geöffnet.
      }
      return false;
    } finally {
      clearTimeout(timeout);
      next.textContent = text;
      next.removeAttribute('aria-disabled');
      this.list.removeAttribute('aria-busy');
      this.loading = false;
    }
  }
}

if (!customElements.get('etana-load-more')) customElements.define('etana-load-more', EtanaLoadMore);
